import { useEffect, useMemo, useState } from 'react';

import { parseSegmentationPayload, parseFeatureToggle } from '../utils/segmentation';
import { fetchSkinAnalysisBundle } from '../utils/skinAnalysisBundle';

const DEFAULTS = {
  loaded: true,
  showConcerns: true,
  showConditions: true,
  advancedCharts: true,
  productSuggestion: true,
  serviceSuggestion: true,
  addToCart: false,
  productLink: false,
  allowedNames: null,
  aiGeneratedSummary: null,
  aiMode: null,
  productSuggestLimit: null,
  productRecommendationSource: 'database',
  productsPageUrl: '',
  productsPageUrls: [],
  primaryProductUrls: [],
};

/** @param {string} [appSessionToken] — brand-admin app_session_token (from report API, not skin flow session id). */
export function useSegmentationConfig(appSessionToken) {
  const resolvedToken = useMemo(
    () => String(appSessionToken || '').trim(),
    [appSessionToken],
  );

  const [config, setConfig] = useState(() => ({
    ...DEFAULTS,
    loaded: !resolvedToken,
  }));

  useEffect(() => {
    const token = resolvedToken;
    if (!token) {
      setConfig({ ...DEFAULTS, loaded: true });
      return undefined;
    }

    let cancelled = false;
    setConfig((prev) => ({ ...prev, loaded: false }));

    fetchSkinAnalysisBundle(token)
      .then((data) => {
        if (cancelled) return;
        const parsed = parseSegmentationPayload(data);
        setConfig({
          loaded: true,
          ...parsed,
          serviceSuggestion:
            data?.service_suggestion != null
              ? parseFeatureToggle(data.service_suggestion)
              : true,
        });
      })
      .catch(() => {
        if (!cancelled) setConfig({ ...DEFAULTS, loaded: true });
      });

    return () => { cancelled = true; };
  }, [resolvedToken]);

  return config;
}
